import get from "lodash/get";

import { IMPORT_SURVEY } from "../types";

const reducer = (state = {}, action) => {
  switch (action.type) {
    case IMPORT_SURVEY:
      return {
        ...state,
        ...get(action, "survey", {})
      };

    default:
      return state;
  }
};

export default reducer;
